module.exports = __webpack_public_path__ + "assets/pictograms/verified-badge.54a96003800575fe17c31098e7a674d6.svg";